export default (function (message) {
  let useTrace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  try {
    if (process.env.NODE_ENV === 'production') return;
  } catch (ex) {
    // process.env.NODE_ENV should be set via WebpackDefinePlugin or as a global in NodeJS.
    // If it is not, the above block will throw. This just discards the exception and
    // leaves it set to the default value, "production".
  }
  if (console) {
    const logFunction = useTrace && console.trace ? console.trace : console.warn;
    logFunction === null || logFunction === void 0 ? void 0 : logFunction.call(console, message);
  }
});
//# sourceMappingURL=warn.js.map